export default class Checker {
    private $el: JQuery;
    private $input: JQuery;
    private $check: JQuery;
    private handlers: any[];

    public constructor($el: JQuery) {
        this.$el = $el;

        this.$input = $el.find('input');
        this.$check = $el.find('.checker');

        this.handlers = [];

        this.initHtml();
    }

    public getElement(): JQuery {
        return this.$el;
    }

    public getInput(): HTMLInputElement {
        return <HTMLInputElement> this.$input[0];
    }

    public setChecked(checked: boolean): void {
        let old = this.isChecked();

        if (old != checked) {
            this.$input.val(checked ? '1' : '0');

            this.updateLayout();

            $.each(this.handlers, (i, func) => {
                func(checked, this);
            });
        }
    }

    public isChecked(): boolean {
        return this.$input.val() == '1';
    }

    public setDisabled(disabled: boolean): void {
        this.$input.prop('disabled', disabled ? 'disabled' : '');
    }

    public onChange(callback: (val: boolean, el?: any, $el?: JQuery) => void): void {
        this.handlers.push(callback);
    }

    private updateLayout() {
        if (this.isChecked()) {
            this.$el.addClass('selected');
        } else {
            this.$el.removeClass('selected');
        }
    }

    private initHtml(): void {
        this.$el.data('xcheck', this);

        this.$el.click((e) => {
            this.setChecked(!this.isChecked());
        });

        this.updateLayout();
    }
};
